var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import DateComponent from './Date';
import Time from './Time';
export default (function (_a) {
    var props = __rest(_a, []);
    if (!props.date) {
        return React.createElement("span", null);
    }
    var date;
    if (!props.date.getMonth) {
        date = new Date(props.date);
    }
    else {
        date = props.date;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(DateComponent, __assign({}, props, { date: date })),
        React.createElement("span", null, "\u00A0"),
        React.createElement(Time, __assign({}, props, { date: date }))));
});
